"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getEnumerableWidth;
var enumerableColumnOffset = 40;
var singleNumberWidth = 8;

function getEnumerableWidth(numberValue) {
  if (numberValue) {
    var valuePlusOne = Number(numberValue) + 1;
    var enumerableStringWidth = singleNumberWidth * valuePlusOne.toString().length;
    return enumerableStringWidth + enumerableColumnOffset;
  }

  return 48;
}